import * as Sentry from "@sentry/tanstackstart-react";
import { expectedErrorKind, logExpectedError } from "#/modules/util.errors/expected";

export function captureUnexpectedError(cause: unknown, flow: string) {
  const kind = expectedErrorKind(cause);
  if (kind) {
    logExpectedError(kind, cause, flow);
    return;
  }
  Sentry.captureException(cause, { tags: { flow } });
}
